import React from 'react';
import {connect} from 'react-redux';
import {AppState} from '@Redux/store';
import {ArmyListUnit} from '@Models';
import {ArmyListUnitArsenalPresenter} from "@Selectors/builder/ArmyListUnitArsenalPresenter";
import { Line } from '@Builder/myArmyList/make/ArmyListUnitArsenal.styled';

export interface IArmyListUnitExportProps {
  armyListUnit: ArmyListUnit
}

const ArmyListUnitArsenal: React.FC<ArmyListUnitExportProps> = ({ count, max, unitName, armyId }) => {
  if(!max)
    return <></>;

  return (
    <Line>
      <i className="fa-solid fa-circle-check"></i> {count} / {max} <a href={`/${document.documentElement.lang}/arsenal/armies/${armyId}`} target="_black" >{unitName}</a>
    </Line>
  );
};

const mapStateToProps = (state: AppState, owsProps: IArmyListUnitExportProps) => ({
  ...ArmyListUnitArsenalPresenter(state, owsProps)
})

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListUnitArsenal);

type ArmyListUnitExportProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
